import store from '@/store';
export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: true,
  dialogClickModal: false,
  column: [
    {
      label: "姓名",
      prop: "name",
      type: "input",
      search: true,
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
      search: true,
    },
    {
      label: "身份证号",
      prop: "cardNo",
      type: "input",
      width: 160
    },
    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      dicData: store.getters.porductTypes,
    },
    {
      label: "申请金额",
      prop: "needAmount",
      type: "input",
    },
    {
      label: "租期",
      prop: "tenancy",
      type: "input",
      formatter:(val,value,label)=>{
        return value ? value + "期" : "-";
      }
    },
    {
      label: "租率",
      prop: "lendingRate",
      type: "input",
      formatter:(val,value,label)=>{
        return value ? value + "%" : "-";
      }
    },

    {
      label: "品牌",
      prop: "carBrand",
      type: "input",
    },
    {
      label: "型号",
      prop: "carModel",
      type: "input",
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      type: "input",
    },
    {
      label: "创建人",
      prop: "createUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建部门",
      prop: "createDept",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: false,
      width: 90,
    },
    {
      label: "修改人",
      prop: "updateUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改时间",
      prop: "updateTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "所属代理商",
      prop: "deptName",
      type: "input",
    },
    {
      label: "状态",
      prop: "status",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "是否已删除",
      prop: "isDeleted",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
  ],
};
